import { useMemo } from "react";
import { Download } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { usePWAInstall } from "@/hooks/use-pwa-install";
import { tailwind } from "@/utilities/tailwind-utils";
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem
} from "@/components/ui/sidebar";
import type { NavigationItem } from "@/types/core";

export function NavSecondary({
  items,
  ...props
}: {
  items: NavigationItem[];
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
  const location = useLocation();
  const { showSidebarInstallCta, handleInstall, isInstalling } =
    usePWAInstall();
  const visibleItems = useMemo(() => items.filter((item) => !item.hidden), [items]);

  return (
    <SidebarGroup {...props}>
      <SidebarGroupContent>
        <SidebarMenu>
          {visibleItems.map((item) => (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton
                asChild
                data-active={location.pathname === item.url}
              >
                <Link to={item.url}>
                  <item.icon />
                  <span>{item.title}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}

          {showSidebarInstallCta && (
            <SidebarMenuItem>
              <SidebarMenuButton
                type="button"
                onClick={() => void handleInstall()}
                disabled={isInstalling}
                className={tailwind.components.buttonGreen}
              >
                <Download className="h-4 w-4" />
                <span>
                  {isInstalling ? "Installing…" : "Install App"}
                </span>
              </SidebarMenuButton>
            </SidebarMenuItem>
          )}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
